import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import { DualAuthService } from '../../services/DualAuthService';
import { BffService } from '../../services/BffService';

@Component({
  selector: 'app-employee-me',
  standalone: true,
  imports: [CommonModule],
  template: `
    <h2>Employee Identity (/whoami)</h2>
    <pre>{{ data | json }}</pre>
  `,
})
export class EmployeeMeComponent implements OnInit {
  data: any;
  private loaded = false;
  constructor(private http: HttpClient, private auth: DualAuthService, private router: Router, private bff: BffService) {}
  ngOnInit(): void {
    this.bff.whoAmI().then(w => {
      if (!w?.authenticated || w.userType !== 'employee') {
        this.router.navigate(['/whoami/customer']);
        return;
      }
      this.data = w;
    }).catch(err => this.data = err);
  }
}
